import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=9b874cea&scoped=true&"
import script from "./AppModal.vue?vue&type=script&lang=ts&"
export * from "./AppModal.vue?vue&type=script&lang=ts&"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=9b874cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b874cea",
  null
  
)

export default component.exports